import classnames from 'classnames/bind';
import { INDICATION_TYPES, IndicationContent } from 'taboola-ultimate-ui';
import { FormattedMessage } from '../../../../../../../taboola-common-frontend-modules/i18n';
import { AddTrackingButton } from '../../../AddTrackingButton/AddTrackingButton';
import commonStyles from '../../../commonEditor.module.scss';
import styles from './missingPixelWarning.module.scss';

const classNameBuilder = classnames.bind(styles);

export const MissingPixelWarning = () => {
    return (
        <IndicationContent
            type={INDICATION_TYPES.WARNING}
            containerClassName={classNameBuilder(styles['warning-indication'], commonStyles['warning-indication'])}
            contentClassName={styles['content']}
        >
            <FormattedMessage
                id="campaign.editor.maxConversions.noPixelOrActiveConversion"
                values={{
                    addTracking: (
                        <AddTrackingButton
                            id="campaign.editor.maxConversions.noPixelOrActiveConversion.action"
                            defaultMessage="tracking"
                        />
                    ),
                }}
            />
        </IndicationContent>
    );
};
